import React, { useState } from "react";
import axios from "axios";
import "./SignUp.css";
import google from "../../../assets/google.png";
import linkedin from "../../../assets/linkedin.png";
import fbook from "../../../assets/facebook.png";

const SignUpForm = ({ onClose, onSuccess }) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [agreed, setAgreed] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSignup = async (e) => {
    e.preventDefault();
    if (!agreed) {
      alert("Please agree to the Terms of Service and Privacy Policy.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(
        "http://localhost:5000/api/v1/user/register",
        { username: `${firstName} ${lastName}`, email, password },
        { headers: { "Content-type": "application/json" } }
      );
      if (onSuccess) onSuccess();
    } catch (error) {
      alert("Sign up failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signupForm">
      <p className="formSubtitle">Join 500,000+ professionals finding their dream jobs every day.</p>

      <div className="socialRow">
        <button className="socialBtn" type="button">
          <img src={google} alt="Google" className="socialIcon" />
          Google
        </button>
        <button className="socialBtn" type="button">
          <img src={linkedin} alt="LinkedIn" className="socialIcon" />
          LinkedIn
        </button>
        <button className="socialBtn" type="button">
          <img src={fbook} alt="Facebook" className="socialIcon" />
          Facebook
        </button>
      </div>

      <div className="divider">
        <span className="dividerText">or sign up with email</span>
      </div>

      <form onSubmit={handleSignup}>
        <div className="inputRow">
          <div className="inputGroup">
            <label className="inputLabel">First Name</label>
            <input
              type="text"
              className="inputField"
              placeholder="Aryan"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
            />
          </div>
          <div className="inputGroup">
            <label className="inputLabel">Last Name</label>
            <input
              type="text"
              className="inputField"
              placeholder="Sharma"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
            />
          </div>
        </div>

        <div className="inputGroup">
          <label className="inputLabel">Email Address</label>
          <input
            type="email"
            className="inputField"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="inputGroup">
          <label className="inputLabel">Password</label>
          <input
            type="password"
            className="inputField"
            placeholder="Create a strong password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        <div className="checkboxRow">
          <input
            type="checkbox"
            id="agree"
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
          />
          <label htmlFor="agree" className="checkboxLabel">
            I agree to the <a href="#">Terms of Service</a> and <a href="#">Privacy Policy</a>
          </label>
        </div>

        <button type="submit" className="submitBtn" disabled={loading || !agreed}>
          {loading ? "Creating account..." : "Create Free Account"}
        </button>
      </form>

      <p className="switchRow">
        Already have an account?{" "}
        <span className="switchLink" onClick={onClose}>Sign in</span>
      </p>
    </div>
  );
};

export default SignUpForm;
